import React from 'react';
import clsx from 'clsx';

import styles from './Contact.module.scss';

interface ContactIcon {
  href?: string;
  icon: string;
  alt: string;
}

interface ContactProps {
  className?: string;
  icons: ContactIcon[];
  text: string;
  textRef?: string;
}

export function Contact({ className, icons, text, textRef }: ContactProps) {
  if (icons.length === 1) {
    const { href, icon, alt } = icons[0];

    const contactContent = (
      <>
        <div className={styles.contact__icons}>
          <img src={icon} alt={alt} />
        </div>
        <div className={styles.contact__text}>{text}</div>
      </>
    );

    return href ? (
      <a href={href} target="_blank" rel="noreferrer" className={clsx(styles.contact, className)}>
        {contactContent}
      </a>
    ) : (
      <div className={clsx(styles.contact, className)}>{contactContent}</div>
    );
  }

  return (
    <div className={clsx(styles.contact, className)}>
      <div className={styles.contact__icons}>
        {icons.map(({ href, icon, alt }, index) => (
          <React.Fragment key={index}>
            <a href={href} target="_blank" rel="noreferrer" className={styles.contact__icon}>
              <img src={icon} alt={alt} />
            </a>
            {index !== icons.length - 1 && <div className={styles.contact__separator} />}
          </React.Fragment>
        ))}
      </div>
      <a href={textRef} className={styles.contact__text}>
        {text}
      </a>
    </div>
  );
}
